import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, TextField, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useState, useEffect } from 'react'

import { MainButton } from '../Button/MainButton'

const useStyles = makeStyles((theme) => ({
    dialogActions: {
        justifyContent: 'flex-start',
        padding: '16px 0px 6px 0px'
    }
}))

const DeleteConfirmation = (props) => {
    const classes = useStyles()

    const [mode, setMode] = useState('Closed')
    const [confirmOpen, setConfirmOpen] = useState(false)

    let {
        isShown,
        setIsShown,
        onConfirmDelete,
        title = 'Delete',
        body = 'Are you sure?',
        isDeleteLoading,
        confirmButtonText,
        currentMode,
        confirmSave
    } = props

    useEffect(() => {
        if (currentMode?.status) setMode(currentMode?.status)
    }, [currentMode])

    const save = (confirmed) => {
        if (mode === 'Closed' || confirmed) return confirmSave({ ...currentMode, status: mode })

        setConfirmOpen(true)
    }

    useEffect(() => {
        if (mode === 'Closed') setConfirmOpen(false)
    }, [mode])

    useEffect(() => {
        if (!isShown) {
            setMode('Closed')
            setConfirmOpen(false)
        }
    }, [isShown])

    return (
        <Dialog
            open={isShown}
            className={classes.dialog}
            onClose={() => {
                if (!isDeleteLoading) setIsShown(false)
            }}
            PaperProps={{
                style: {
                    minWidth: '475px',
                    maxWidth: '475px',
                    width: '475px'
                }
            }}>
            <DialogTitle>
                <Typography
                    style={{
                        fontFamily: 'Nunito',
                        color: '#1A1A35',
                        fontSize: '16px',
                        lineHeight: '22px',
                        textTransform: 'uppercase',
                        fontWeight: '800',
                        marginBottom: 16
                    }}>
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent style={{ paddingTop: 0 }}>
                <TextField
                    select
                    label="Mode"
                    value={mode}
                    style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
                    onChange={(e) => setMode(e.target.value)}
                    variant="filled">
                    <MenuItem value='Open' style={{ textTransform: 'capitalize' }}>
                        Open
                    </MenuItem>
                    <MenuItem value='Closed' style={{ textTransform: 'capitalize' }}>
                        Closed
                    </MenuItem>
                </TextField>
                {
                    confirmOpen && <Typography variant="body1" style={{
                        fontSize: 16, fontWeight: '600'
                    }}>Are you sure you want to change this mode to 'Open'? This action may impact the section's capacity.</Typography>
                }
                {
                    confirmOpen ? (
                        <DialogActions className={classes.dialogActions}>
                            <MainButton
                                variant="contained"
                                label={'CONFIRM'}
                                backgroundColor="#EB4C4C"
                                onClick={() => save(true)}
                            />
                            <MainButton
                                variant="outlined"
                                label="CANCEL"
                                onClick={() => setIsShown(false)}
                                disabled={isDeleteLoading}
                            />
                        </DialogActions>
                    ) : (

                        <DialogActions className={classes.dialogActions}>
                            <MainButton
                                variant="contained"
                                label={'SAVE'}
                                backgroundColor="#6B4AD6"
                                onClick={() => save(false)}
                            />
                            <MainButton
                                variant="outlined"
                                label="CANCEL"
                                onClick={() => setIsShown(false)}
                                disabled={isDeleteLoading}
                            />
                        </DialogActions>
                    )
                }
            </DialogContent>
        </Dialog>
    )
}

export default DeleteConfirmation
